module.exports = __webpack_public_path__ + "img/b5-5.e260123.png";